import { withInstall } from "../utils/index.mjs";
import _SkeletonAvatar from "./SkeletonAvatar.mjs";
const SkeletonAvatar = withInstall(_SkeletonAvatar);
var stdin_default = SkeletonAvatar;
import { skeletonAvatarProps } from "./SkeletonAvatar.mjs";
export {
  SkeletonAvatar,
  stdin_default as default,
  skeletonAvatarProps
};
